export enum GreyRibbonWithShareButtonPositionEnum {
  BEFORE = 'BEFORE',
  AFTER = 'AFTER',
  REPLACE = 'REPLACE',
}

export interface IGreyRibbonWithShareButtonDescription {
  description: string;
  position: GreyRibbonWithShareButtonPositionEnum;
}
